import React from 'react';

class BannerNotice extends React.Component {

  render() {
    return (
  		<p>
            We Only Fund Domestic US Organizations and 99% of the Funded Organizations Receive PRI's.
      </p>
    );
  }
}


export default BannerNotice;


// WEBPACK FOOTER //
// ./src/components/BannerNotice.js